import request from '@/utils/request'


// 查询发现-文章话题列表
export function listDiscoverPostTopic(query) {
  return request({
    url: '/discovery/discover/post/topic/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现-文章话题分页
export function pageDiscoverPostTopic(query) {
  return request({
    url: '/discovery/discover/post/topic/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现-文章话题详细
export function getDiscoverPostTopic(data) {
  return request({
    url: '/discovery/discover/post/topic/detail',
    method: 'get',
    params: data
  })
}

// 新增发现-文章话题
export function addDiscoverPostTopic(data) {
  return request({
    url: '/discovery/discover/post/topic/add',
    method: 'post',
    data: data
  })
}

// 修改发现-文章话题
export function updateDiscoverPostTopic(data) {
  return request({
    url: '/discovery/discover/post/topic/edit',
    method: 'post',
    data: data
  })
}

// 删除发现-文章话题
export function delDiscoverPostTopic(data) {
  return request({
    url: '/discovery/discover/post/topic/delete',
    method: 'post',
    data: data
  })
}
